import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-nrs-navy text-white" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-22">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-23">
            <img src="https://cdn.magicpatterns.com/uploads/rgcJwPHo8cNW53rsocngGA/NewRiver-Logo-FC-1000x287v2.png" alt="New River Systems" className="h-10 w-auto mb-3 brightness-0 invert" data-id="element-24" />
            <p className="text-sm text-blue-200 leading-relaxed" data-id="element-25">
              ServiceNow Governance & Platform Stewardship
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-blue-200" data-id="element-26">
              <MailIcon className="h-4 w-4 text-nrs-orange flex-shrink-0" data-id="element-27" />
              <a href="mailto:info@newriversystems.com" className="hover:text-white transition-colors" data-id="element-28">
                info@newriversystems.com
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-29">
            <h4 className="font-heading font-700 text-sm uppercase tracking-wider text-nrs-orange mb-4" data-id="element-30">
              Services
            </h4>
            <ul className="space-y-2 text-sm text-blue-200" data-id="element-31">
              <li data-id="element-32">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-33">
                  Governance Services
                </Link>
              </li>
              <li data-id="element-34">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-35">
                  Development Services
                </Link>
              </li>
              <li data-id="element-36">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-37">
                  Platform Operations
                </Link>
              </li>
              <li data-id="element-38">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-39">
                  Combined Packages
                </Link>
              </li>
              <li data-id="element-40">
                <Link to="/nipr-jwics" className="hover:text-white transition-colors" data-id="element-41">
                  NIPR/JWICS Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-42">
            <h4 className="font-heading font-700 text-sm uppercase tracking-wider text-nrs-orange mb-4" data-id="element-43">
              Resources
            </h4>
            <ul className="space-y-2 text-sm text-blue-200" data-id="element-44">
              <li data-id="element-45">
                <Link to="/thought-leadership" className="hover:text-white transition-colors" data-id="element-46">
                  Thought Leadership
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/case-studies" className="hover:text-white transition-colors" data-id="element-48">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/calculator" className="hover:text-white transition-colors" data-id="element-50">
                  Risk Calculator
                </Link>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-white transition-colors" data-id="element-52">
                  White Papers
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-white transition-colors" data-id="element-54">
                  Webinars
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-55">
            <h4 className="font-heading font-700 text-sm uppercase tracking-wider text-nrs-orange mb-4" data-id="element-56">
              Company
            </h4>
            <ul className="space-y-2 text-sm text-blue-200" data-id="element-57">
              <li data-id="element-58">
                <a href="#" className="hover:text-white transition-colors" data-id="element-59">
                  About NRS
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="hover:text-white transition-colors" data-id="element-61">
                  Our Team
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-white transition-colors" data-id="element-63">
                  Careers
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-white transition-colors" data-id="element-65">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-blue-800 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-66">
          <p className="text-sm text-blue-300" data-id="element-67">
            © 2024 New River Systems. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-sm text-blue-300" data-id="element-68">
            <ShieldCheckIcon className="h-4 w-4 text-nrs-orange" data-id="element-69" />
            <span data-id="element-70">TS/SCI Cleared Team</span>
            <span className="mx-2" data-id="element-71">|</span>
            <span data-id="element-72">Federal Contractor</span>
            <span className="mx-2" data-id="element-73">|</span>
            <span data-id="element-74">ServiceNow Partner</span>
          </div>
        </div>
      </div>
    </footer>;
}